import pdfPageTitle from './PDFPageTitle';

export default ({ title, description, colorClass = 'print.primary.7' }, { title: titleOptions, h, image } = {}) => {
    const pageTitle = pdfPageTitle({ title, description, colorClass: 'print.light' }, { title: titleOptions });
    const page = { position: 'page', h, pageTitle };
    page.background = { colour: colorClass };
    page.font = 'background';
    if (image) {
        let { position } = image;
        const y = 136;
        // Default image position - Full side view, adjust the content to other side
        if (!image.position) {
            position = 'col-2';
            pageTitle.position = 'col-1';
            pageTitle.y = y;
        }
        page.image = {
            y,
            h: image.height,
            w: image.width,
            position,
            ...image
        };
    }
    return page;
};
